import {
  TRADE_LITE_ROUTE,
  TRADE_MT5_ROUTE,
  TRADE_PRO_ROUTE,
  TRADE_ROUTE,
} from "_constants";
import { lazy } from "react";

const Trade = lazy(() => import("pages/trade"));
const TradeMT5 = lazy(() => import("pages/trade/mt5"));
const TradeLite = lazy(() => import("pages/trade/lite"));
const TradePro = lazy(() => import("pages/trade/pro"));

export const tradeRoutes = [
  { path: TRADE_ROUTE, element: <Trade /> },
  { path: TRADE_MT5_ROUTE, element: <TradeMT5 /> },
  { path: TRADE_LITE_ROUTE, element: <TradeLite /> },
  { path: TRADE_PRO_ROUTE, element: <TradePro /> },
];
